import { __rest } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import Picker from 'rc-picker';
import dayjsConfigs from 'rc-picker/lib/generate/dayjs';
import viLocale from 'rc-picker/lib/locale/vi_VN';
import { BackOutlined, ForwardOutlined, JumpBackOutlined, JumpForwardOutlined, CalendarOutlined, DeleteCircleFilled, ArrowDownFilled } from '@teko-builder/icons';
import styled from '@emotion/styled';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { useRef, useState } from 'react';
import { I as Input } from './InputNumber-7d93e963.js';
import customParseFormat from 'dayjs/plugin/customParseFormat';

const StyledPicker = styled.div `
  border: 1px solid #bcbfd6;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  > * {
    align-self: center;
  }

  .rc-picker-input {
    padding-left: 24px;
  }

  height: 32px;
  &.small {
    height: 24px;
    .rc-picker {
      padding: 0 4px;
    }
  }
  &.large {
    height: 40px;
    .rc-picker {
      padding: 8px;

      .rc-picker-input {
        > input {
          font-size: 13px;
        }
      }
    }
  }

  .rc-picker {
    padding: 0 8px;
    &.rc-picker-focused {
      border: none;
    }
    .rc-picker-input {
      > input {
        font-size: 12px;
        border: none;
        &:focus {
          outline: none;
        }
      }

      .rc-picker-clear {
        right: 0;
      }
    }
    .rc-picker-dropdown {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-variant: tabular-nums;
      line-height: 1.5715;
      list-style: none;
      font-feature-settings: 'tnum';
      position: absolute;
      z-index: 1050;
      box-shadow: none !important;
    }

    .rc-picker-panel-container {
      overflow: hidden;
      vertical-align: top;
      background: #fff;
      border-radius: 2px;
      box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%),
        0 9px 28px 8px rgb(0 0 0 / 5%);
      transition: margin 0.3s;

      .rc-picker-panel {
        vertical-align: top;
        background: 0 0;
        border-radius: 0;
        display: inline-flex;
        flex-direction: column;
        text-align: center;
        background: #fff;
        outline: none;
        border: none;
      }
    }

    .rc-picker-header {
      display: flex;
      padding: 0 8px;
      color: rgba(0, 0, 0, 0.85);
      border-bottom: 1px solid #f0f0f0;
    }

    .rc-picker-header-view {
      flex: auto;
      font-weight: 500;
      line-height: 40px;

      button {
        color: inherit;
        font-weight: inherit;
        padding: 0;
        line-height: 40px;
        background: 0 0;
        border: 0;
        cursor: pointer;
        transition: color 0.3s;

        &:not(:first-of-type) {
          margin-left: 8px;
        }
      }
    }

    .rc-picker-header > button {
      min-width: 1.6em;
      padding: 0;
      color: rgba(0, 0, 0, 0.25);
      line-height: 40px;
      background: 0 0;
      border: 0;
      cursor: pointer;
      transition: color 0.3s;
    }

    .rc-picker-body {
      padding: 8px 12px;

      .rc-picker-content {
        width: 252px;
      }
    }

    .rc-picker-panel .rc-picker-footer {
      border-top: 1px solid #f0f0f0;
      width: min-content;
      min-width: 100%;
      line-height: 38px;
      text-align: center;
      border-bottom: 1px solid transparent;
      background: #fff;
      border-top: 1px solid #f0f0f0;
      width: min-content;
      min-width: 100%;
      line-height: 38px;
      text-align: center;
      border-bottom: 1px solid transparent;
      background: #fff;
    }

    .rc-picker-ranges {
      margin-bottom: 0;
      padding: 4px 12px !important;
      overflow: hidden;
      line-height: 34px;
      text-align: left;
      list-style: none;

      > li {
        display: inline-block;
      }
    }

    .rc-picker-now {
      text-align: left;
    }

    .rc-picker-ranges .rc-picker-ok {
      float: right;
      margin-left: 8px;
    }

    .rc-picker-dropdown .rc-picker-panel > .rc-picker-time-panel {
      padding-top: 4px;
    }

    .rc-picker-time-panel-column {
      flex: 1 0 auto;
      width: 56px !important;
      margin: 0;
      padding: 0;
      overflow-y: hidden;
      text-align: left;
      list-style: none;
      transition: background 0.3s;

      > li.rc-picker-time-panel-cell-selected .rc-picker-time-panel-cell-inner {
        background: #e6f7ff;
      }
    }

    .rc-picker-cell-inner,
    .rc-picker-time-panel-cell-inner {
      font-size: 14px;
    }

    .rc-picker-now-btn,
    .rc-picker-today-btn {
      cursor: pointer;
      color: #1890ff !important;
    }

    .rc-picker-time-panel-cell-inner:hover {
      background: #f5f5f5;
    }

    .rc-picker-cell-inner:hover {
      background-color: #f5f5f5 !important;
    }

    .rc-picker-time-panel-column:hover {
      overflow-y: auto;
    }
  }
`;

dayjs.locale('vi');
const CustomButton = (props) => (jsx("button", Object.assign({ type: "button" }, props, { children: "Xong" })));
const DateTimePickerDesktop = (_a) => {
    var { value, onChange, type = 'date', placeholder, size = 'default' } = _a, rest = __rest(_a, ["value", "onChange", "type", "placeholder", "size"]);
    let configs = {
        generateConfig: dayjsConfigs,
        locale: viLocale,
        prevIcon: jsx(BackOutlined, {}),
        nextIcon: jsx(ForwardOutlined, {}),
        superPrevIcon: jsx(JumpBackOutlined, {}),
        superNextIcon: jsx(JumpForwardOutlined, {}),
    };
    switch (type) {
        case 'time':
            configs = Object.assign(Object.assign({}, configs), { picker: 'time', placeholder, format: 'HH:mm' });
            break;
        case 'datetime':
            configs = Object.assign(Object.assign({}, configs), { showTime: true, placeholder, format: 'DD/MM/YYYY HH:mm' });
            break;
        default:
            configs = Object.assign(Object.assign({}, configs), { picker: 'date', placeholder, format: 'DD/MM/YYYY' });
    }
    return (jsxs(StyledPicker, Object.assign({}, rest, { className: size }, { children: [jsx(CalendarOutlined, { style: {
                    position: 'absolute',
                    left: '16px',
                    fontSize: '18px',
                    color: '#c8c8c8',
                } }), jsx(Picker, Object.assign({}, configs, { onChange: onChange, value: value, allowClear: true, clearIcon: jsx(DeleteCircleFilled, { style: { fontSize: 16 }, onClick: (e) => {
                        e.stopPropagation();
                        onChange(undefined);
                    } }), suffixIcon: jsx(ArrowDownFilled, {}), placeholder: placeholder || configs.format, showToday: true, components: {
                    button: CustomButton,
                }, style: { width: '100%' }, getPopupContainer: (triggerNode) => triggerNode, showSecond: false }))] })));
};

dayjs.extend(customParseFormat);
const mapDateTimeType = {
    datetime: 'datetime-local',
    date: 'date',
    time: 'time',
};
const DateTimePickerMobile = ({ value, onChange, type = 'date', placeholder, size = 'default', style, }) => {
    const inputRef = useRef();
    const [tempValue, setTempValue] = useState();
    const getDisplayValue = (val) => {
        if (!val)
            return undefined;
        try {
            if (type === 'datetime')
                return dayjs(val).format('DD/MM/YYYY HH:mm');
            if (type === 'date')
                return dayjs(val).format('DD/MM/YYYY');
            if (type === 'time')
                return dayjs(val).format('HH:mm');
        }
        catch (_a) {
            return undefined;
        }
    };
    const handleChange = (e) => {
        let newValue;
        if (e.target.value) {
            if (type === 'datetime') {
                newValue = new Date(e.target.value);
            }
            else if (type === 'date') {
                newValue = new Date(e.target.value);
            }
            else if (type === 'time') {
                newValue = dayjs(e.target.value, 'HH:mm').toDate();
            }
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
        setTempValue(newValue);
    };
    return (jsx(Fragment, { children: jsxs(Wrapper, Object.assign({ style: { position: 'relative' } }, { children: [jsx(Input, { onClick: () => inputRef.current.click(), readOnly: true, value: getDisplayValue(value) || getDisplayValue(tempValue), style: style, size: size, placeholder: placeholder }), jsx(StyledInputDate, { ref: inputRef, type: mapDateTimeType[type], onChange: handleChange })] })) }));
};
const Wrapper = styled.div `
  position: relative;
`;
const StyledInputDate = styled.input `
  width: 0;
  height: 0;
  position: absolute;
  visibility: hidden;
`;

export { DateTimePickerMobile as D, DateTimePickerDesktop as a };
